export default {"src":"/_next/static/media/hofBannerDark.7508598c.svg","height":404,"width":1296};